module.exports = __webpack_public_path__ + "764cd4e6bca69c7bad0afc8e8e138eb9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hair-bun.png
// module id = 2825
// module chunks = 0